<template>
    <el-dialog
      :visible.sync="hide_show_non_coverage_activity"
      :fullscreen="true"
      custom-class="combined-non-coverage-activities"
      :close-on-click-modal="false"
    >
      <div class="p-relative">
          <div class="non-coverage-activity-header">
              <div class="dialog-heading">
                  <h6 v-if="checkCompany.is_mcd || checkCompany.is_mcd_north" class="combined-activity-title">Fixed / Non-Coverage Activities - Hourly View <span class="capitalize">({{ getOutletName(outlet) }})</span></h6>
                  <h6 v-else class="combined-activity-title">Non-Coverage Activities - Hourly View <span class="capitalize">({{ getOutletName(outlet) }})</span></h6>
              </div>
              <span class="cursor-pointer close-icon" @click="closeNonCoverageHourlyModal">
                  <i class="el-icon-circle-close"></i>
              </span>
          </div>
      
          <!-- Filters -->
          <el-row :gutter="20">
              <el-col :span="12">
                  <div class="display-flex">
                      <div>
                          <p>Day(s)</p>
                          <el-select
                              v-model="selected_hourly_days"
                              multiple
                              filterable
                              size="small"
                              collapse-tags
                              placeholder="Select days"
                              @change="handleDayOpt($event)"
                          >
                              <el-option
                                  v-for="(dayItem, index) in daysList"
                                  :key="'selected_filter_days_'+index"
                                  :label="dayItem.label"
                                  :value="dayItem.value"
                                  :disabled="(selected_hourly_days.includes('all') && dayItem.value != 'all')"
                              ></el-option>
                          </el-select>
                      </div>
                      <div>
                          <p>Activities</p>
                          <el-select
                              v-model="selected_hourly_filter_activities"
                              multiple
                              filterable
                              collapse-tags
                              size="small"
                              placeholder="Select activities"
                          >
                              <template v-for="(activity, activityIndex) in activity_type_list">
                                  <el-option
                                      v-if="all_unique_hourly_activities.includes(activity.id)"
                                      :key="activityIndex"
                                      :value="activity.id"
                                      :label="activity.name"
                                  >
                                      {{ activity.name }}
                                  </el-option>
                              </template>
                          </el-select>
                      </div>
                  </div>
              </el-col>
              <el-col :span="12" class="text-right py-4" style="min-height: 72px">
                  <template v-if="non_coverage_activity_hourly_view && non_coverage_activity_hourly_view.length">
                      <!-- <el-tooltip content="Bulk Edit" placement="bottom" size="mini"> -->
                          <el-button
                              :disabled="!(hasAdminAccess || postOnboardingAccess) "
                              class="mr-2 cursor-pointer p-1 bulk-edit-btn"
                              @click="hide_show_bulk_edit_non_coverage_popup = true"
                          >
                              <img :disabled="!(hasAdminAccess || postOnboardingAccess) " src="../../../../../assets/icons/edit-icon.svg" width="12" alt="edit" />&nbsp;&nbsp;Bulk Edit
                          </el-button>
                      <!-- </el-tooltip> -->
                      <!-- <el-tooltip content="Download" placement="bottom" size="mini"> -->
                          <el-button
                              class="mr-2 cursor-pointer p-1 bulk-edit-btn"
                              @click="downloadBulkHourlyNonCoverageData"
                          >
                              <img src="../../../../../assets/icons/download.svg" width="12" alt="download" />
                          </el-button>
                      <!-- </el-tooltip> -->
                  </template>
              </el-col>
          </el-row>
      
          <!-- Main body -->
          <div id="hourly_non_coverage_data">
              <template  v-for="(element, elementIndex) in non_coverage_activity_hourly_view">
                  <div v-if="!selected_hourly_days || !selected_hourly_days.length || selected_hourly_days.includes('all') || selected_hourly_days.includes(element.day)" :key="'non-coverage-activity-index-'+elementIndex" class="mb-16">
                      <p class="sectional-heading my-2 capitalize combined-view-hourly-title">{{ element.day }}</p>
                      <!-- Summary -->
                      <!-- <div class="non-coverage-summary mt-2 mb-4">
                          <div v-for="(item, index) in element.time_slot_and_function" :key="'non-coverage-summary-data-index-'+index" class="summary-items">
                              <p class="counter">{{ Object.values(item).map(el => el ? el : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}</p>
                              <div class="summary-item__name">{{ getActivityName(index) }}</div>
                          </div>
                      </div> -->
                      <div class="daily-view-non-coverage-activities__wrapper">
                          <table class="daily-view-non-coverage-activities">
                              <thead>
                                  <tr>
                                      <th class="main-cell header-cell">
                                          <div style="border-right: 1px solid black; padding: 8px;">Activity</div>
                                      </th>
                                      <th v-for="(item, index) in nonCoverageDailyViewLabels" :key="'table-col-non-cov-'+index" class="header-cell" :colspan="(staffDetails.forecast_and_schedule_time_interval === '00:30:00') ? 2: 1">
                                          {{ item.value }}
                                      </th>
                                      <th class="header-cell" style="min-width: 145px;">Labour Hour Total</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <template v-for="(item, index) in element.time_slot_and_function">
                                      <tr v-if="!selected_hourly_filter_activities.length || selected_hourly_filter_activities.includes(index)" :key="'non-coverage-data-index-'+index">
                                          <td class="main-cell">{{ getActivityName(index) }}</td>
                                          <td
                                              v-for="(timeItem, timeIndex) in item"
                                              :key="'timing-index-'+timeIndex"
                                              class="inside-cell"
                                          >
                                              <el-input v-model="item[timeIndex]" v-mask="'###'" :readonly="!(hasAdminAccess || postOnboardingAccess) " type="number" min="0" class="ns-number-field"></el-input>
                                          </td>
                                          <td v-if="staffDetails.forecast_and_schedule_time_interval === '00:30:00'" class="inside-cell calculation-cell ttt">{{ (Object.values(item).map(el => el ? el : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)/2) }}</td>
                                          <td v-else class="inside-cell calculation-cell ttt">{{ Object.values(item).map(el => el ? el : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}</td>
                                      </tr>
                                  </template>
                                  <tr class="calculative-cell">
                                      <td class="main-cell header-cell">Total</td>
                                      <td v-for="(item, index) in calculateTimeWiseData(element.time_slot_and_function)" :key="'inside-item'+index" class="inside-cell" >
                                          {{ item }}
                                      </td>
                                      <td v-if="staffDetails.forecast_and_schedule_time_interval === '00:30:00'" class="inside-cell">
                                          {{ (Object.values(calculateTimeWiseData(element.time_slot_and_function)).reduce((acc, cur) => acc + cur, 0)/2) }}
                                      </td>
                                      <td v-else class="inside-cell">
                                          {{ Object.values(calculateTimeWiseData(element.time_slot_and_function)).reduce((acc, cur) => acc + cur, 0) }}
                                      </td>
                                      <!-- 
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['07-00'] ? el['07-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['08-00'] ? el['08-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['09-00'] ? el['09-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['10-00'] ? el['10-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['11-00'] ? el['11-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['12-00'] ? el['12-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['13-00'] ? el['13-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['14-00'] ? el['14-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['15-00'] ? el['15-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['16-00'] ? el['16-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['17-00'] ? el['17-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['18-00'] ? el['18-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['19-00'] ? el['19-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['20-00'] ? el['20-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['21-00'] ? el['21-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['22-00'] ? el['22-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['23-00'] ? el['23-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['00-00'] ? el['00-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['01-00'] ? el['01-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['02-00'] ? el['02-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['03-00'] ? el['03-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['04-00'] ? el['04-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['05-00'] ? el['05-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) }}
                                      </td>
                                      <td class="inside-cell">
                                          {{ 
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['06-00'] ? el['06-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['07-00'] ? el['07-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['08-00'] ? el['08-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['09-00'] ? el['09-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['10-00'] ? el['10-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['11-00'] ? el['11-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['12-00'] ? el['12-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['13-00'] ? el['13-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['14-00'] ? el['14-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['15-00'] ? el['15-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['16-00'] ? el['16-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['17-00'] ? el['17-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['18-00'] ? el['18-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['19-00'] ? el['19-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['20-00'] ? el['20-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['21-00'] ? el['21-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['22-00'] ? el['22-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['23-00'] ? el['23-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['00-00'] ? el['00-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['01-00'] ? el['01-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['02-00'] ? el['02-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['03-00'] ? el['03-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['04-00'] ? el['04-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                              +
                                              Object.values(filteredHourlyActivities(element.time_slot_and_function)).map((el) => el['05-00'] ? el['05-00'] : 0).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0)
                                          }}
                                      </td> -->
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                  </div>
              </template>
          </div>
  
          <div v-if="non_coverage_activity_hourly_view && non_coverage_activity_hourly_view.length" class="dummy-div"></div>
  
          <el-row v-if="non_coverage_activity_hourly_view && non_coverage_activity_hourly_view.length && !hide_show_bulk_edit_non_coverage_popup" :gutter="20" class="action-button__wrapper">
              <el-col :span="24" class="text-right">
                  <el-button
                      type="warning"
                      size="small"
                      :disabled="!(hasAdminAccess || postOnboardingAccess) "
                      class="primary-settings-button__save"
                      @click.prevent="updateHourlyView"
                  >
                      Save
                  </el-button>
              </el-col>
          </el-row>
      
          <template v-if="!non_coverage_activity_hourly_view || !non_coverage_activity_hourly_view.length">
              <div class="mb-2 text-center">
                  No data available
              </div>
          </template>
          <!-- Bulk Edit Non-Coverage Activities -->
          <BulkEditNonCoverageActivitiesOld v-if="hide_show_bulk_edit_non_coverage_popup" />
      </div>
    </el-dialog>
  </template>
  
  <script>
  import settingsMixin from "../../../../../../mixins/settingsMixin";
  import BulkEditNonCoverageActivitiesOld from "../storeSettings/BulkEditNonCoverageActivitiesOld.vue";
  export default {
      name: "CombinedNonCoverageActivityOld",
      components: {
          BulkEditNonCoverageActivitiesOld
      },
      mixins: [settingsMixin],
      watch: {
          hide_show_bulk_edit_non_coverage_popup(newValue, oldValue) {
              let classes = document.getElementsByClassName('v-modal');
              if(newValue === false) {
                  if(classes && classes.length) {
                      classes[0].setAttribute('style', 'display: none;');
                  }
              } else {
                  if(classes && classes.length) {
                      classes[0].setAttribute('style', 'display: block;');
                  }
              }
          }
      },
      mounted(){
          if(!this.selected_hourly_days.length) {
              this.selected_hourly_days.push('monday');
          }
      }
  }
  </script>
  
  <style lang="scss">
  .non-coverage-summary {
      padding: 22px;
      /* background: #F6F7F9; */
      background: #FFFFFF;
      border-radius: 12px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      overflow-x: auto;
      .summary-items {
          display: flex;
          flex-direction: column;
          .counter {
              font-family: 'Open Sans';
              font-style: normal;
              font-weight: 600;
              font-size: 20px;
              text-align: center;
              color: #333333;
              line-height: 27px;
              width: 120px;
          }
          .summary-item__name {
              font-family: 'Open Sans';
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              text-align: center;
              color: #666666;
              width: 120px;
          }
      }
  }
  .non-coverage-activity-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
  }
  .daily-view-non-coverage-activities__wrapper {
      background: #fff;
      border-radius: 12px;
      border: 1px solid #E7E7E7;
      padding: 45px 30px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      .daily-view-non-coverage-activities {
          /* border: 1px solid #E7EAEF; */
          border: none;
          thead {
              tr {
                  th:not(:first-child) {
                      padding: 8px;
                      text-align: center;
                      /* border: 1px solid #E7EAEF; */
                      font-size: inherit;
                  }
                  th:first-child{
                      border-right: none !important;
                  }
              }
          }
          tbody tr {
              td {
                  padding: 0;
                  text-align: center;
                  border-bottom: 1px solid #E7EAEF;
                  font-size: inherit;
                  .el-input__inner {
                      /* border-color: #00000012 !important; */
                      border-color: transparent !important;
                      padding: 0 4px !important;
                      text-align: center !important;
                  }
              }
              td:last-child {
                  padding: 8px;
              }
          }
      }
      .calculative-cell {
          .inside-cell {
              font-weight: 600;
          }
      }
      .calculation-cell {
          font-weight: 600;
      }
  }
  .combined-non-coverage-activities {
      .el-dialog__header {
          display: none;
      }
      .bulk-edit-btn {
          padding: 8px 12px;
          background-color: #FFFFFF;
          border-radius: 8px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      }
      .bulk-edit-btn:focus, .bulk-edit-btn:hover {
          color: #606266;
          border-color: #DCDFE6;
      }
      .display-flex {
          display: flex;
          flex-direction: row;
          column-gap: 10px;
          p {
              font-weight: 700;
              font-size: 12px;
              margin-bottom: 4px;
          }
      }
      .close-icon {
          font-size: 28px;
          color: #333;
      }
      .p-relative {
          position: relative;
          .action-button__wrapper {
              position: fixed;
              bottom: 0;
              z-index: 9;
              width: 100%;
              padding: 10px 35px;
              background-color: #fff;
              border-top: 1px solid #E7E7E7;
          }
          .dummy-div {
              width: 100%;
              height: 80px;
          }
      }
  }
  .main-cell {
      min-width: 100px;
      font-size: 12px;
      line-height: 1.15rem;
  }
  .header-cell {
      min-width: 50px;
      font-size: 12px;
      font-weight: 700;
  }
  .inside-cell {
      min-width: 50px;
      height: 57px;
      font-size: 12px;
      vertical-align: bottom;
      .el-input {
          margin-top: 8px;
          height: 80%;
          .el-input__inner {
              border: none !important;
              height: 80%;
          }
          .el-input__inner:focus {
              border: 1px solid #E7E7E7 !important;
          }
          .el-input__inner:hover {
              cursor: pointer;
          }
      }
  }
  .combined-activity-title {
      font-size: 18px;
      font-weight: 700;
      font-family: inherit;
  }
  .combined-view-hourly-title {
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      font-family: inherit;
      text-transform: capitalize;
      margin-bottom: 20px;
      margin-top: 25px;
  }
  @media (max-width: 1600px) {
      .daily-view-non-coverage-activities {
          font-size: 12px !important;
          tbody {
              tr {
                  td {
                      .el-input {
                          .el-input__inner {
                              font-size: 12px !important;
                          }
                      }
                  }
              }
          }
      }
  }
  @media (max-width: 1500px) {
      .daily-view-non-coverage-activities {
          font-size: 11px !important;
          tbody {
              tr {
                  td {
                      .el-input {
                          .el-input__inner {
                              font-size: 11px !important;
                          }
                      }
                  }
              }
          }
      }
  }
  @media (max-width: 1400px) {
      .daily-view-non-coverage-activities {
          font-size: 10px !important;
          tbody {
              tr {
                  td {
                      .el-input {
                          .el-input__inner {
                              font-size: 10px !important;
                          }
                      }
                  }
              }
          }
      }
  }
  @media (max-width: 1300px) {
      .daily-view-non-coverage-activities {
          font-size: 9px !important;
          tbody {
              tr {
                  td {
                      .el-input {
                          .el-input__inner {
                              font-size: 9px !important;
                          }
                      }
                  }
              }
          }
      }
  }
  @media (max-width: 991) {
      .daily-view-non-coverage-activities {
          font-size: 8px !important;
          tbody {
              tr {
                  td {
                      .el-input {
                          .el-input__inner {
                              font-size: 8px !important;
                          }
                      }
                  }
              }
          }
      }
  }
  .display-none {
      display: none;
  }
  .capitalize {
      text-transform: capitalize;
  }
  // Updated style
  .daily-view-non-coverage-activities{
      max-height: 650px !important;
      overflow-x: auto !important;
      overflow-y: auto !important;
      display: block;
      table {
      width: 100%;
      border-collapse: collapse;
      }
  
      thead {
          position: sticky;
          top: 0;
          background: #f9a168;
          z-index: 2;
          color: #fff;
          border-bottom: 1px solid #606266 !important;
          tr {
              th{
                  border-left: 1px solid #606266 !important;
                  border-top: 1px solid #606266 !important;
                  border-bottom: 1px solid #606266 !important;
                  // border: 1px solid #606266 !important;
              }
              th:nth-child(2){
                  border-left-color: #f9a168 !important;
              }
          }
      }
      thead th:first-child {
          position: sticky;
          left: 0;
          z-index: 2000;
          background: #f9a168;
          color: #fff;
          width: 250px !important;
      }
      tbody {
          tr {
              td{
                  border: 1px solid #606266 !important;
              }
              td:nth-child(even) {
                  border-right-color: #C3C3C3 !important;
              }
              td:last-child{
                  border-right-color: #606266 !important;
              }
          }
      }
      tbody td:first-child {
          width: 250px !important;
          position: sticky;
          left: 0;
          z-index: 1;
          background: white;
      }
  }
  ::-webkit-scrollbar-track {
    background: #F1F1F1;
  }
  ::-webkit-scrollbar-thumb {
    background: #C1C1C1;
  }
  ::-webkit-scrollbar {
    height: 8px;
    overflow: visible;
    width: 8px;
  }
  </style>
  